import { Component, ElementRef, Input, OnInit, OnDestroy, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import lottie, { AnimationItem } from 'lottie-web';

@Component({
    selector: 'app-lottie-animation',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div #lottieContainer [style.width]="width" [style.height]="height" [class]="containerClass"></div>
  `,
    styles: [`
    :host {
      display: block;
    }
  `]
})
export class LottieAnimationComponent implements OnInit, OnDestroy, OnChanges {
    @ViewChild('lottieContainer', { static: true }) lottieContainer!: ElementRef;

    @Input() animationData: any;
    @Input() path?: string;
    @Input() loop: boolean = true;
    @Input() autoplay: boolean = true;
    @Input() width: string = '100%';
    @Input() height: string = '100%';
    @Input() containerClass: string = '';
    @Input() speed: number = 1;

    private animation: AnimationItem | null = null;

    ngOnInit() {
        this.loadAnimation();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['animationData'] && !changes['animationData'].firstChange) {
            if (this.animation) {
                this.animation.destroy();
            }
            this.loadAnimation();
        }
    }

    ngOnDestroy() {
        if (this.animation) {
            this.animation.destroy();
        }
    }

    private loadAnimation() {
        if (!this.lottieContainer) {
            return;
        }

        const config: any = {
            container: this.lottieContainer.nativeElement,
            renderer: 'svg',
            loop: this.loop,
            autoplay: this.autoplay,
            speed: this.speed
        };

        if (this.animationData) {
            config.animationData = this.animationData;
        } else if (this.path) {
            config.path = this.path;
        }

        try {
            this.animation = lottie.loadAnimation(config);
        } catch (error) {
            console.error('Error loading Lottie animation:', error);
        }
    }

    play() {
        if (this.animation) {
            this.animation.play();
        }
    }

    pause() {
        if (this.animation) {
            this.animation.pause();
        }
    }

    stop() {
        if (this.animation) {
            this.animation.stop();
        }
    }

    goToAndStop(frame: number) {
        if (this.animation) {
            this.animation.goToAndStop(frame, true);
        }
    }

    goToAndPlay(frame: number) {
        if (this.animation) {
            this.animation.goToAndPlay(frame, true);
        }
    }
}
